<script>
  import {
    Link,
    page
  } from '@inertiajs/svelte'

  import LinkToUnlessCurrent from "../components/_link_to_unless_current.svelte"
  import LinkToIf from "../components/_link_to_if.svelte"
  import { isSamePageIgnoringLocale } from '../../javascript/utils'

  import {
    configure,
    config,
    root_path,
    tos_path,
    privacy_path,
    commercial_disclosure_path,
  } from '../../javascript/routes'

  import { I18n } from "i18n-js"
  import i18n_translations from "../../javascript/locales.json"
  import docxIcon from '../../javascript/images/modules/translations/index/docx.webp'
  import docxIcon2x from '../../javascript/images/modules/translations/index/docx@2x.webp'
  import xlsxIcon from '../../javascript/images/modules/translations/index/xlsx.webp'
  import xlsxIcon2x from '../../javascript/images/modules/translations/index/xlsx@2x.webp'
  import pptxIcon from '../../javascript/images/modules/translations/index/pptx.webp'
  import pptxIcon2x from '../../javascript/images/modules/translations/index/pptx@2x.webp'
  import keyIcon from '../../javascript/images/modules/translations/index/key.webp'
  import keyIcon2x from '../../javascript/images/modules/translations/index/key@2x.webp'

  // Reactive prop from Inertia
  //let RailsApp = $derived($page.props.RailsApp)
  let { RailsApp } = $props()

  // Initialize i18n
  const i18n = new I18n(i18n_translations)
  i18n.locale = RailsApp.I18n.locale

  const fileTypes = [
    { name: 'Word', path: 'word', icon: docxIcon, iconSrcset: `${docxIcon} 1x, ${docxIcon2x} 2x` },
    { name: 'Excel', path: 'excel', icon: xlsxIcon, iconSrcset: `${xlsxIcon} 1x, ${xlsxIcon2x} 2x` },
    { name: 'PowerPoint', path: 'powerpoint', icon: pptxIcon, iconSrcset: `${pptxIcon} 1x, ${pptxIcon2x} 2x` },
    { name: 'Keynote', path: 'keynote', icon: keyIcon, iconSrcset: `${keyIcon} 1x, ${keyIcon2x} 2x` }
  ]
  const footerFileTypes = i18n.locale === 'en'
    ? fileTypes
    : fileTypes.filter(fileType => fileType.path !== 'powerpoint')

  configure({
    default_url_options: {locale: i18n.locale},
  })

  function generateLocaleUrl(newLocale) {
    const url = new URL(window.location.href)
    url.searchParams.set("locale", newLocale) // Override or add the locale param
    return url.toString()
  }
</script>
<footer class="pt-3 pb-3 mt-5 pt-5">
  <div class="container">
    <div class="copyright">
      {@html i18n.t('layout.footer.copyright', {
      logo: `<a aria-label="${i18n.t('logo')}" href="${root_path()}">${i18n.t('logo')}</a>`
      })}
    </div>
    <div class="d-block d-sm-flex row-gap-2 column-gap-5">
      <ol class="links mt-4 mb-0 p-0">
        <li>
          <LinkToIf aria-label="{i18n.t('Page.Tos.title')}" condition={!isSamePageIgnoringLocale($page.url, tos_path())} href="{tos_path()}">
            {i18n.t('Page.Tos.title')}
          </LinkToIf>
        </li>
        <li>
          <LinkToIf aria-label="{i18n.t('Page.Privacy.title')}" condition={!isSamePageIgnoringLocale($page.url, privacy_path())} href="{privacy_path()}">
            {i18n.t('Page.Privacy.title')}
          </LinkToIf>
        </li>
        <li>
          <LinkToIf aria-label="{i18n.t('Page.CommercialDisclosure.title')}" condition={!isSamePageIgnoringLocale($page.url, commercial_disclosure_path())} href="{commercial_disclosure_path()}">
            {i18n.t('Page.CommercialDisclosure.title')}
          </LinkToIf>
        </li>
      </ol>
      <ol class="links mt-4 mb-0 p-0 flex-grow-1">
        {#each RailsApp.I18n.available_locales as l}
          <li>
            {#if l != i18n.locale}
              <Link aria-label="{i18n.t('locale_name', {locale: l})}" href="{generateLocaleUrl(l)}" class="locale">{i18n.t('locale_name', {locale: l})}</Link>
            {:else}
              {i18n.t('locale_name', {locale: l})}
            {/if}
          </li>
        {/each}
      </ol>
      <ol class="links mt-4 mb-0 p-0">
        {#if i18n.locale === 'en'}
          {#each footerFileTypes as fileType}
            {#each ['ja', 'es', 'de'] as targetLocale}
              {@const lang = RailsApp.Models.Language.ALLOWED_LANGUAGES.find(l => l.locale === targetLocale)}
              {#if lang}
                <li>
                  <Link class="d-inline-flex align-items-center gap-1" href={`/${fileType.path}?locale=en&target_language_id=${lang.id}`}>
                    <img src={fileType.icon} srcset={fileType.iconSrcset} alt="" aria-hidden="true" width="16" height="16" />
                    Translate {fileType.name} to {lang.name}
                  </Link>
                </li>
              {/if}
            {/each}
          {/each}
        {:else if i18n.locale === 'ja'}
          {#each footerFileTypes as fileType}
            {#each ['en', 'zh-CN', 'zh-TW'] as targetLocale}
              {@const lang = RailsApp.Models.Language.ALLOWED_LANGUAGES.find(l => l.locale === targetLocale)}
              {#if lang}
                <li>
                  <Link class="d-inline-flex align-items-center gap-1" href={`/${fileType.path}?locale=ja&target_language_id=${lang.id}`}>
                    <img src={fileType.icon} srcset={fileType.iconSrcset} alt="" aria-hidden="true" width="16" height="16" />
                    {fileType.name}を{lang.name}に翻訳
                  </Link>
                </li>
              {/if}
            {/each}
          {/each}
        {:else if i18n.locale === 'zh-CN'}
          {#each footerFileTypes as fileType}
            {#each ['en', 'ja', 'zh-TW'] as targetLocale}
              {@const lang = RailsApp.Models.Language.ALLOWED_LANGUAGES.find(l => l.locale === targetLocale)}
              {#if lang}
                <li>
                  <Link class="d-inline-flex align-items-center gap-1" href={`/${fileType.path}?locale=zh-CN&target_language_id=${lang.id}`}>
                    <img src={fileType.icon} srcset={fileType.iconSrcset} alt="" aria-hidden="true" width="16" height="16" />
                    把{fileType.name}翻译成{lang.name}
                  </Link>
                </li>
              {/if}
            {/each}
          {/each}
        {:else if i18n.locale === 'zh-TW'}
          {#each footerFileTypes as fileType}
            {#each ['en', 'ja', 'zh-CN'] as targetLocale}
              {@const lang = RailsApp.Models.Language.ALLOWED_LANGUAGES.find(l => l.locale === targetLocale)}
              {#if lang}
                <li>
                  <Link class="d-inline-flex align-items-center gap-1" href={`/${fileType.path}?locale=zh-TW&target_language_id=${lang.id}`}>
                    <img src={fileType.icon} srcset={fileType.iconSrcset} alt="" aria-hidden="true" width="16" height="16" />
                    將{fileType.name}翻譯成{lang.name}
                  </Link>
                </li>
              {/if}
            {/each}
          {/each}
        {/if}
      </ol>
    </div>
  </div>
</footer>
